import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from './loading';
import Image from './image';
import { getProblems } from '../utils/api';

const Print = () => {
  const { problemId } = useParams();
  const [p, setP] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (problemId) {
      const id = parseInt(problemId);
      getProblems(null, id)
      .then((data) => {
        setP(data[0]);
      })
      .catch((error) => {
        console.warn(error);
        setError(error);
        alert(error.toString());
      });
    }
  }, [problemId]);

  useEffect(() => {
    if (p) {
      const timer = setTimeout(() => {
        window.print();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [p]);

  if (error) {
    return <span><h3>Error</h3>{error.toString()}</span>;
  }

  if (!p) {
    return <Loading/>;
  }

  return (
    <div style={{textAlign: 'center'}}>
      <span>#{p.nr} {p.type} {p.grade} ({p.creator})</span>
      <Image mediaId={p.mediaId} shapesIn={p.shapes} width={p.width} height={p.height} maxHeight="95vh" alignLeft={false} onClick={null}/>
    </div>
  );
}

export default Print;